import {
  DriverMixerAdjustmentsDetail,
  DriverMixerAdjustmentsDetailRequest,
  DriverMixerAdjustmentsInfoItem,
  DriverMixerAdjustmentsItem,
} from 'bus/driverMixerAdjustments/types';

import { PayloadRequest } from 'types/requestTypes';

import { omdApi } from '../api';

const driverMixerAdjustmentsApi = omdApi.injectEndpoints({
  endpoints: (builder) => ({
    // Основные методы для DriverMixerAdjustments
    getDriverMixerAdjustments: builder.query<DriverMixerAdjustmentsItem, PayloadRequest>({
      query: (data) => ({
        url: `/v1/driverMixerAdjustments/${data.id}`,
      }),
    }),
    createDriverMixerAdjustments: builder.mutation<void, DriverMixerAdjustmentsItem>({
      query: (data) => ({
        url: '/v1/driverMixerAdjustments/',
        method: 'POST',
        body: data,
      }),
    }),
    editDriverMixerAdjustments: builder.mutation<void, DriverMixerAdjustmentsItem>({
      query: (data) => ({
        url: `/v1/driverMixerAdjustments/${data.id}`,
        method: 'PUT',
        body: data,
      }),
    }),
    deleteDriverMixerAdjustments: builder.mutation<void, PayloadRequest>({
      query: (data) => ({
        url: `/v1/driverMixerAdjustments/${data.id}`,
        method: 'DELETE',
      }),
    }),
    getDriverMixerAdjustmentsInfo: builder.query<DriverMixerAdjustmentsInfoItem, PayloadRequest>({
      query: (data) => ({
        url: `/v1/driverMixerAdjustments/${data.id}/info`,
      }),
    }),

    // Методы для DriverMixerAdjustmentsDetail
    getDriverMixerAdjustmentsDetailList: builder.query<DriverMixerAdjustmentsDetail[], PayloadRequest>({
      query: (data) => ({
        url: `/v1/driverMixerAdjustments/${data.id}/details`,
      }),
    }),
    getDriverMixerAdjustmentsDetailOne: builder.query<DriverMixerAdjustmentsDetail, PayloadRequest>({
      query: (data) => ({
        url: `/v1/driverMixerAdjustments/details/${data.id}`,
      }),
    }),
    createDriverMixerAdjustmentsDetail: builder.mutation<void, DriverMixerAdjustmentsDetailRequest>({
      query: (data) => ({
        url: `/v1/driverMixerAdjustments/${data.adjustmentId}/details`,
        method: 'POST',
        body: data,
      }),
    }),
    editDriverMixerAdjustmentsDetail: builder.mutation<void, DriverMixerAdjustmentsDetailRequest>({
      query: (data) => ({
        url: `/v1/driverMixerAdjustments/details/${data.id}`,
        method: 'PUT',
        body: data,
      }),
    }),
    deleteDriverMixerAdjustmentsDetail: builder.mutation<void, PayloadRequest>({
      query: (data) => ({
        url: `/v1/driverMixerAdjustments/details/${data.id}`,
        method: 'DELETE',
      }),
    }),

    // Методы для DriverMixerSalary
    createDriverMixerSalary: builder.mutation<void, { date: string; driverId: number; comment: string }>({
      query: (data) => ({
        url: '/v1/driverMixerSalary/',
        method: 'POST',
        body: data,
      }),
    }),
  }),
});

export const {
  useGetDriverMixerAdjustmentsQuery,
  useLazyGetDriverMixerAdjustmentsQuery,
  useCreateDriverMixerAdjustmentsMutation,
  useEditDriverMixerAdjustmentsMutation,
  useDeleteDriverMixerAdjustmentsMutation,
  useGetDriverMixerAdjustmentsInfoQuery,
  useLazyGetDriverMixerAdjustmentsInfoQuery,
  useGetDriverMixerAdjustmentsDetailListQuery,
  useLazyGetDriverMixerAdjustmentsDetailListQuery,
  useGetDriverMixerAdjustmentsDetailOneQuery,
  useLazyGetDriverMixerAdjustmentsDetailOneQuery,
  useCreateDriverMixerAdjustmentsDetailMutation,
  useEditDriverMixerAdjustmentsDetailMutation,
  useDeleteDriverMixerAdjustmentsDetailMutation,
  useCreateDriverMixerSalaryMutation,
} = driverMixerAdjustmentsApi;
